import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { ApplicationState, DistributorThunkDispatch } from '../types';

// Use throughout the app instead of plain `useDispatch` and `useSelector`. These have better types.
export const useAppDispatch = () => useDispatch<DistributorThunkDispatch>();
export const useAppSelector: TypedUseSelectorHook<ApplicationState> = useSelector;
